import LoginTemplate from './LoginTemplate'

export default LoginTemplate
